// extracted by mini-css-extract-plugin
module.exports = {"resizable":"TextArea_resizable__7g_t_","error":"TextArea_error__9OQPr","errorLabel":"TextArea_errorLabel__2TkL-"};